var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 6.66586C6.78579 6.66628 6.57822 6.59169 6.4133 6.45503L0.913301 1.8717C0.726103 1.7161 0.60838 1.49252 0.586032 1.25012C0.563684 1.00773 0.638541 0.766393 0.794135 0.579194C0.949728 0.391996 1.17331 0.274274 1.4157 0.251926C1.6581 0.229578 1.89944 0.304434 2.08663 0.460028L6.99997 4.56669L11.9133 0.606695C12.0071 0.530551 12.115 0.473689 12.2308 0.439376C12.3466 0.405064 12.468 0.393978 12.5881 0.406756C12.7082 0.419533 12.8246 0.455922 12.9306 0.513831C13.0366 0.571741 13.1302 0.650029 13.2058 0.744195C13.2897 0.838448 13.3533 0.949022 13.3926 1.06899C13.4318 1.18896 13.4458 1.31573 13.4338 1.44137C13.4217 1.56702 13.3839 1.68881 13.3225 1.79914C13.2612 1.90947 13.1778 2.00595 13.0775 2.08253L7.57747 6.51003C7.40781 6.62508 7.20448 6.67995 6.99997 6.66586Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.7f169d0de53ccdcd66cef29de3571824.svg";
export { ForwardRef as ReactComponent };